module.exports = __webpack_public_path__ + "static/media/icon_facebook.6c9db3c0.svg";